/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { FinnairPassengerRequest } from '../../models/finnair-passenger-request';

export interface UpdatePassengerDetails$Params {
  orderId: string;
  locale?: string;
  hash?: string;
      body: FinnairPassengerRequest
}

export function updatePassengerDetails(http: HttpClient, rootUrl: string, params: UpdatePassengerDetails$Params, context?: HttpContext): Observable<DapiHttpResponse<void>> {
  const rb = new DapiRequestBuilder(rootUrl, updatePassengerDetails.PATH, 'post');

  if (params) {
    rb.path('orderId', params.orderId, {});
    rb.query('locale', params.locale, {});
    rb.query('hash', params.hash, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as DapiHttpResponse<void>;
    }),
    catchErrorAsJson()
  );
}

updatePassengerDetails.PATH = '/api/v2/order/{orderId}/passengers';
